import { render } from "./CarrerSummaryCard.vue?vue&type=template&id=ddb46cfa&scoped=true&ts=true"
import script from "./CarrerSummaryCard.vue?vue&type=script&lang=ts"
export * from "./CarrerSummaryCard.vue?vue&type=script&lang=ts"

import "./CarrerSummaryCard.vue?vue&type=style&index=0&id=ddb46cfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb46cfa"]])

export default __exports__